import React, { Component } from 'react';

import { NotificationsUtils } from '../utils';
import { Routes as routes } from '../navigation';
import { Header, Line } from '../components';
import '../css/SignIn.css';

class LinkedPractices extends Component {

  constructor(props) {
    super(props);
    this.state = {
      newSelectedRole: '',
      displaySignInForPractice: '',
      signInSelectedRole: '',
    }
  }

  componentDidMount() {
    if (this.props.selectedRole) {
      this.setState({ ...this.state, newSelectedRole: this.props.selectedRole });
    }
  }

  renderOtherPractices = (display, otherPractices, allRoles) => {
    if (!display) {
      return null;
    }

    const otherPracticesArray = otherPractices || [];
    const otherPracticesRows = otherPracticesArray.map((practice, index) => {

      const practiceID = practice._id;
      const rolesForThisPractice = allRoles && allRoles[practiceID] ? allRoles[practiceID] : null;
      const notificationsDict = this.props.notifications && this.props.notifications.notificationsDict ? this.props.notifications.notificationsDict : {};
      const notificationsForPractice = NotificationsUtils.getPracticeNotificationCount(practiceID, notificationsDict);

      let subscription = practice && practice.subscription ? practice.subscription : {};
      let plan_label   = this.getPlanLabel(practice.subscription);
      if (!rolesForThisPractice) {
        return null;
      }

      var roleOptions = [];
      roleOptions = rolesForThisPractice.admin            ?  [ ...roleOptions, { label: 'Admin',            role: 'admin'            }] : roleOptions;
      roleOptions = rolesForThisPractice.practice_manager ?  [ ...roleOptions, { label: 'Practice Manager', role: 'practice_manager' }] : roleOptions;
      roleOptions = rolesForThisPractice.practice_owner   ?  [ ...roleOptions, { label: 'Practice Owner',   role: 'practice_owner'   }] : roleOptions;
      roleOptions = rolesForThisPractice.vet              ?  [ ...roleOptions, { label: 'Veterinarian',     role: 'vet'              }] : roleOptions;
      roleOptions = rolesForThisPractice.behaviorist      ?  [ ...roleOptions, { label: 'Behaviorist',      role: 'behaviorist'      }] : roleOptions;
      roleOptions = rolesForThisPractice.tech             ?  [ ...roleOptions, { label: 'Tech',             role: 'tech'             }] : roleOptions;

      var roleOptionsButtons = roleOptions.map((roleOption) => {
        return <input type="submit"
                      value={roleOption.label}
                      className="button-clear-blue"
                      key={roleOption.role}
                      style={{ margin: 5, fontSize: 13, color: roleOption.role === this.state.signInSelectedRole ? '#1dc2ff' : '', backgroundColor: roleOption.role === this.state.signInSelectedRole ? '#e8f8ff' : '' }}
                      onClick={ () => { this.setState({ ...this.state, signInSelectedRole: roleOption.role }) }}
                    />
      })

      const displaySignInForPractice = this.state.displaySignInForPractice && this.state.displaySignInForPractice === practiceID ? true : false;

      return <div key={practice._id} className="flex-container-column">
        <div className="flex-container flex-container-row flex-space-between flex-center-align" style={{  }}>
          <div className='flex-container-row flex-center-align'>
            <div className='flex-container-column'>
              <span style={{ fontSize: 14, color: '#636c70' }}>{ practice.name }</span>
              <span style={{ fontSize: 11, color: '#1dc2ff' }}>{ plan_label    }</span>
            </div>
            { notificationsForPractice && notificationsForPractice > 0 ? <div className='flex-container-row' style={{ height: 20, width: 20, borderRadius: 10, backgroundColor: 'red', justifyContent: 'center', alignItems: 'center', marginLeft: 10 }}>
              <span style={{ fontSize: 10, fontWeight: 'bold', color: 'white' }}>{ notificationsForPractice }</span>
            </div> : null }
          </div>
          { displaySignInForPractice ? null : <span className="icon-button"
                                                    style={{ fontSize: 13, padding: 5, paddingRight: 0 }}
                                                    onClick={ () => { this.setState({ ...this.state, displaySignInForPractice: practiceID, signInSelectedRole: '' }) }}
                                                    >Sign In</span>}

        </div>
        { displaySignInForPractice
        ? <div className="flex-container-column">
            <span style={{ marginTop: 5, fontSize: 13, color: 'grey' }}>Select a role to sign in as:</span>
            <div className="flex-container-row">
              { roleOptionsButtons }
            </div>
            <div className="flex-container-row" style={{ marginTop: 5, justifyContent: 'flex-end' }}>
              <input  type="submit"
                      value="Cancel"
                      style={{ marginRight: 5, fontSize: 13 }}
                      className="button-clear"
                      onClick={ () => { this.setState({ ...this.state, displaySignInForPractice: '', signInSelectedRole: '' }) }}
                    />
              <input  type="submit"
                      value="Sign In"
                      style={{ backgroundColor: this.state.signInSelectedRole === '' ? 'grey' : '#1dc2ff', fontSize: 13 }}
                      className="button-default"
                      onClick={ () => {
                        if (this.state.signInSelectedRole !== '' && this.state.displaySignInForPractice !== '') {
                          this.props.contextActions.switchLoggedInPracticeAndRole(this.state.displaySignInForPractice, this.state.signInSelectedRole);
                        }
                      }}
                    />
              </div>
          </div>
        : null }
        <Line hide={ otherPracticesArray.length === index + 1 } style={{ marginTop: 12, marginBottom: 12, backgroundColor: '#f3f3f3' }}/>
      </div>
    })

    return <div>
      <div style={{ backgroundColor: '#f3f3f3', height: 1, width: '100%', marginTop: 12, marginBottom: 12 }}></div>
      { otherPracticesRows }
    </div>

  }

  renderSwitchRolesViewButton = (selectedRole) => {

    if (this.state.newSelectedRole === selectedRole) {
      return null;
    }

    const roleLabelMap = {
      'admin': 'Admin',
      'practice_manager': 'Practice Manager',
      'practice_owner': 'Practice Owner',
      'vet': 'Veterinarian',
      'behaviorist': 'Behaviorist',
      'tech': 'Tech',
    }

    return <div className="flex-container-row" style={{ margin: 10, marginBottom: 0, justifyContent: 'flex-end' }}>
      <input  type="submit"
              className="button-default"
              value={'Switch To ' + roleLabelMap[this.state.newSelectedRole] + ' View'}
              style={{ padding: 10, color: 'white', backgroundColor: '#1dc2ff' }}
              onClick={ () => { this.switchRoleAction() }}
            />
    </div>
  }

  renderAllLinkedPractices = (selectedPractice, selectedRole, allPractices, allRoles) => {
    if (selectedPractice && selectedRole && allPractices && allRoles) {

      const practice = allPractices[selectedPractice];
      const roles = allRoles[selectedPractice] || {};

      var roleOptions = [];

      roleOptions = roles.admin            ?  [ ...roleOptions, { label: 'Admin',            role: 'admin'            }] : roleOptions;
      roleOptions = roles.practice_manager ?  [ ...roleOptions, { label: 'Practice Manager', role: 'practice_manager' }] : roleOptions;
      roleOptions = roles.practice_owner   ?  [ ...roleOptions, { label: 'Practice Owner',   role: 'practice_owner'   }] : roleOptions;
      roleOptions = roles.vet              ?  [ ...roleOptions, { label: 'Veterinarian',     role: 'vet'              }] : roleOptions;
      roleOptions = roles.behaviorist      ?  [ ...roleOptions, { label: 'Behaviorist',      role: 'behaviorist'      }] : roleOptions;
      roleOptions = roles.tech             ?  [ ...roleOptions, { label: 'Tech',             role: 'tech'             }] : roleOptions;

      const allOtherPractices = Object.keys(allPractices).map((practiceID) => {
        const roleApprovedForThisPractice = allRoles[practiceID] && allRoles[practiceID].approved === true ? true : false;
        if (practiceID === selectedPractice || roleApprovedForThisPractice === false) {
          return null;
        }
        if (allPractices[practiceID]) {
          return allPractices[practiceID];
        }
      }).filter((prac) => { return prac });

      const displayOtherPracticesSection = allOtherPractices.length > 0 ? true : false;

      var roleOptionsButtons = roleOptions.map((roleOption) => {
        return <input type="submit"
                      value={roleOption.label}
                      className="button-clear"
                      key={roleOption.role}
                      style={{ margin: 5, fontSize: 13, color: roleOption.role === this.state.newSelectedRole ? '#1dc2ff' : '', backgroundColor: roleOption.role === this.state.newSelectedRole ? '#e8f8ff' : '' }}
                      onClick={ () => { this.setState({ ...this.state, newSelectedRole: roleOption.role }) }}
                    />
      })

      return <div className="standard-container">
        <Header title='My Practices' icon='fas fa-store-alt' />
        <div className='flex-container-column' style={{ padding: 15 }}>
          <div className="flex-container flex-container-column">
            <div className="flex-container-row flex-space-between space-center-align">
              <span style={{ fontSize: 14, color: '#636c70' }}>{ practice.name }</span>
              <span style={{ fontSize: 11, color: 'grey', marginTop: 7 }}>CURRENTLY SIGNED IN</span>
            </div>
            <div style={{ marginTop: 5 }}>{ roleOptionsButtons }</div>
            { this.renderSwitchRolesViewButton(selectedRole) }
          </div>
          { this.renderOtherPractices(displayOtherPracticesSection, allOtherPractices, allRoles) }
        </div>
      </div>
    } else {
      return null;
    }
  }

  render() {
    return this.renderAllLinkedPractices(this.props.selectedPractice, this.props.selectedRole, this.props.practices, this.props.roles);
  }

  switchRoleAction = () => {
    this.props.contextActions.switchLoggedInRole(this.state.newSelectedRole);
  }

  switchPracticeAction = () => {
    this.props.contextActions.switchLoggedInPracticeAndRole();
  }

  getPlanLabel = (subscription) => {
    let subscription_type = subscription && subscription.subscription_type ? subscription.subscription_type : '';
    let label = '';

    let label_dict = {
      'INSTANT': 'Instant',
      'INSTANT_PAID': 'Instant+',
      'CORE': 'Professional',
      'ENTERPRISE': 'Enterprise'
    }

    label = label_dict[subscription_type];
    return label ? label.toUpperCase() : label;
  }

}


export default LinkedPractices
